import ExternalLinks from './ExternalLinks';

export default ExternalLinks;
